import * as React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import {CloudComponent, ResolvedCloudArtifact} from '@mintdata-wsp/common/state/ui/visualDesigner/VisualDesignerState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {action} from 'mobx';
import bind from 'bind-decorator';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ErrorPopupSide, Input, InputStyle} from '@mintdata-wsp/wsp/ui/components/forms/Input';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Scrollable, ScrollBehavior} from '@mintdata-wsp/wsp/ui/components/scrollable/Scrollable';
import {FlowArtifact, FlowSection} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {FlowSectionView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/components/FlowSectionView';

const styles = require('./FlowComponentsPanel.less');
const cx = classnames.bind(styles);

@observer
export class FlowComponentsPanel extends React.Component<any, any>
{
    @bind
    _renderFilterUI()
    {
        return <Row className={cx('filterRow')}>
            <Input
                style={InputStyle.Simple}
                className={cx('inputField')}
                placeholder={'Search for a block'}
                errorPopupSide={ErrorPopupSide.Bottom}
                initialValue={''}
                isInitiallyFocused={true}
                isValidFn={(value:string) => true}
                onChange={action((newValue:any) =>
                {
                    const controller = controllers.ui.flowComponentsPanel;

                    if( !newValue || newValue.length === 0 )
                        controller.clearFilterString();
                    else
                        controller.setFilterString(newValue);

                    return true;
                })} />
        </Row>;
    }

    @bind
    _renderSection(section:FlowSection)
    {
        return <FlowSectionView section={section} />;
    }

    @bind
    _renderComponents()
    {
        const controller = controllers.ui.flowComponentsPanel;
        const manifest = controller.getManifest();

        if( !manifest )
            return null;

        return manifest.artifacts.map((a:FlowArtifact) =>
        {
            return a.sections.map((s:FlowSection) =>
            {
                return this._renderSection(s);
            });
        });
    }

    render()
    {
        return <Column className={cx('panelRoot')}>
            {this._renderFilterUI()}
            <Scrollable className={cx('panelContent')}
                        containerClassName={cx('panelContentContainer')}
                        isScrollX={false}
                        isScrollY={true}
                        behavior={ScrollBehavior.OnHover}>

                <Column className={cx('flowComponents')}>
                    {this._renderComponents()}
                </Column>

            </Scrollable>

        </Column>;
    }
}
